/**完成订单 评价订单**/
<template>
  <div class="affirm">
    <div class="grade">
      <div class="grade-text">您的评价会让司机做的更好</div>
      <div class="grade-star">
        <xk-star @clickChange="starFn" :defScore="5" :isShow="isShow" :disabled="disabled"></xk-star>
      </div>
      <div class="remark" v-if="status !== 40 || remark">
        <div class="remark-text">您的意见</div>
        <div class="textarea" v-if="!disabled">{{remark}}</div>
        <textarea class="textarea" placeholder="请输入您宝贵的意见或建议，以便于帮助我们改善服务 质量" v-model="remark" maxlength="60" v-else></textarea>
      </div>
    </div>
    <div class="submit" v-if="status !== 40">
      <span @click="submitFn">提交评价</span>
    </div>
    <xk-hint-Box :time="1500" v-if="hintBox.state" :state="hintBox.showState" :content="hintBox.content">
    </xk-hint-Box>
    <xk-upload-mod :state="loadState"></xk-upload-mod>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import XkUploadMod from '../../module/uploadMod/src/uploadMod'
  import XkHintBox from '../../module/hintBox/src/hintBox'
  import XkStar from '../../module/star/src/star'

  export default {
    components: {
      XkUploadMod,
      XkHintBox,
      XkStar
    },
    name: 'affirm',
    computed: {
      ...mapGetters({
        DjOrderInfo: 'DjOrderInfo',
        loginData: 'loginData'
      })
    },
    data () {
      return {
        disabled: true, // 是否能点击
        isShow: false,
        score: '',
        tagsVal: [], // 选择的标签
        tags: [], // 标签
        remark: '', // 备注
        loadState: false,
        order_id: '', // 订单id
        status: '', // 订单状态
        hintBox: {
          state: false,
          showState: 'yes',
          content: ''
        } // 模态状态,
      }
    },
    methods: {
      /**
       * @returns void
       * @desc 获取单个订单信息
       */
      async getOrderFn () {
        let url = '/v1/orderFindOne'
        let params = {
          'app_key': window.configure.appKey,
          'order_id': this.order_id
        }
        let data = await this.$axios.get(url, params)
        if (data && data.code === 1) {
          this.remark = data.order.rate_content || ''
        }
      },
      starFn (msg) { // 星星的回掉函数
        this.score = msg
      },
      submitFn () { // 保存事件
        let that = this
        if (that.score !== '' && that.score) {
          that.loadState = true
          that.$store.dispatch('DjEvaluateOrder', {
            passenger_id: window.configure.passengerInfo.id,
            order_id: that.order_id,
            score: that.score,
            remark: that.remark,
            fn: (data) => {
              that.loadState = false
              if (data && data.code === 1) {
                that.hintBox = {
                  state: true,
                  showState: 'yes',
                  content: '评价成功！'
                }
                setTimeout(() => {
                  that.hintBox = false
                  that.$store.dispatch('unfilledOrderState', {type: 'daijia', state: false})
                  // that.$router.push({path: '/daijia?app_key=' + window.configure.appKey})
                  that.$router.replace({path: '/orderRecord', query: {active: 2}})
                }, 1500)
              }
            }
          })
        } else {
          that.hintBox = {
            state: true,
            showState: 'no',
            content: '请选择星级后评价！'
          }
          setTimeout(() => {
            that.hintBox = false
          }, 1500)
        }
      }
    },
    mounted: function () {
      this.order_id = this.$route.query.order_id
      this.status = this.$route.query.status || ''
      if (this.status === 40) {
        this.disabled = false
        this.getOrderFn()
      }
      // let that = this
      // that.$store.dispatch('checkLogin', (state) => {
      //   if (state) {
      //   } else {
      //     that.$router.push('/login')
      //   }
      // })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .affirm {
    min-height: 100%;
    .grade {
      width: 100%;
      padding: 24px 16px 0;
      box-sizing: border-box;
      background-color: #fff;
      .grade-text{
        font-size:14px;
        font-weight:500;
        color:rgba(34,34,34,1);
        line-height:20px;
      }
      .grade-star{
        padding: 27px 0 58px;
        text-align: center;
        .score{
          margin-top: 0;
        }
      }
      .remark {
        box-sizing: border-box;
        padding-top: 24px;
        width: 100%;
        border-top: 1px #EBEBEB solid;
        .remark-text{
          font-size:14px;
          font-weight:500;
          color:rgba(34,34,34,1);
          line-height:20px;
          margin-bottom: 8px;
        }
        .textarea{
          width: 100%;
          height: 96px;
          border: none;
          font-family: "Microsoft YaHei UI";
          &::placeholder{
            font-size:14px;
            font-weight:400;
            color:rgba(204,204,204,1);
            line-height:20px
          }
        }
      }
    }
    .submit {
      margin: 72px 16px 0;
      box-sizing: border-box;
      /*width: 100%;*/
      background-color: #EA6550;
      height: 44px;
      border-radius: 4px;
      span {
        display: block;
        width: 100%;
        text-align: center;
        font-size:16px;
        line-height: 44px;
        font-weight:400;
        color:rgba(255,255,255,1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// affirm.vue?99f4a5c6